import { computed, ref } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { Apii } from '@/services/api.js';

const ApiService = new Apii();

export function useSubscription() {
    const page = usePage();

    const isSubscribed = computed(() => {
        return page.props.userData?.is_subscribed === true;
    });

    const requiresSubscription = (callback) => {
        if (!isSubscribed.value) {
            window.location.href = '/10xtravel-plus/upgrade';
            return false;
        }
        if (callback && typeof callback === 'function') {
            callback();
        }
        return true;
    };

    const checkSubscription = async () => {
        try {
            const response = await ApiService.apiCall(
                '/travel-plus/check-access',
                'get'
            );
            return response.data;
        } catch (error) {
            console.error('Failed to check subscription status:', error);
            return { is_subscribed: false, access_type: null };
        }
    };

    return {
        isSubscribed,
        requiresSubscription,
        checkSubscription,
    };
}
